/*
* modal
*/
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

export default class LinkScroll {
  constructor() {
    this.$smoothScroll = document.querySelectorAll('[data-target="smoothScroll"]');
  }

  attachEvent() {
    Array.prototype.forEach.call( this.$smoothScroll, $link => {
      $link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = $link.getAttribute('href');
        document.querySelector(targetId).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });
  }
}
